import * as React from "react";
const ArrowUp = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || 24}
    height={props.height || 24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={props.fill || "#666666"}
      d="M11.0065 7.6125L6.10646 12.5125C5.90646 12.7125 5.67312 12.8083 5.40646 12.8C5.13979 12.7917 4.90646 12.6875 4.70646 12.4875C4.52312 12.2875 4.42729 12.0542 4.41896 11.7875C4.41062 11.5208 4.50646 11.2875 4.70646 11.0875L11.3065 4.4875C11.4065 4.3875 11.5148 4.31667 11.6315 4.275C11.7481 4.23333 11.8731 4.2125 12.0065 4.2125C12.1398 4.2125 12.2648 4.23333 12.3815 4.275C12.4981 4.31667 12.6065 4.3875 12.7065 4.4875L19.3065 11.0875C19.4898 11.2708 19.5815 11.5 19.5815 11.775C19.5815 12.05 19.4898 12.2875 19.3065 12.4875C19.1065 12.6875 18.869 12.7875 18.594 12.7875C18.319 12.7875 18.0815 12.6875 17.8815 12.4875L13.0065 7.6125V18.7875C13.0065 19.0708 12.9106 19.3083 12.719 19.5C12.5273 19.6917 12.2898 19.7875 12.0065 19.7875C11.7231 19.7875 11.4856 19.6917 11.294 19.5C11.1023 19.3083 11.0065 19.0708 11.0065 18.7875V7.6125Z"
    />
  </svg>
);
export default ArrowUp;
